<template>
  <v-container>
    <page-header-title v-if="!enrolmentDone" :title="$t('fe.enrolment.interest_title')" class="enr-title"></page-header-title>

    <v-form ref="form">
      <v-container grid-list-md class="pa-0">
        <v-layout wrap>
          <v-flex xs12 v-if="!enrolmentDone">
            <v-container grid-list-md class="pa-0">
              <v-layout wrap>
                <v-flex lg8 md8 sm12 xs12 v-if="!enrolmentDone">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text class="pa-4 enr-course-description">
                        <span style="white-space: break-spaces">{{ $t("fe.enrolment.interest_description") }}</span>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-tabs background-color="var(--v-primary-darken2)" class="enr-tabs darken-2" dark v-model="active_tab" grow>
                    <v-tab :to="'/f/' + this.locale + '/enrolment/organisation/interest'" class="subheading">{{
                      $t("fe.enrolment.organisation_title")
                    }}</v-tab>
                    <v-tab :to="'/f/' + this.locale + '/enrolment/personal/interest'" class="subheading">{{
                      $t("fe.enrolment.personal_title")
                    }}</v-tab>
                  </v-tabs>

                  <v-card>
                    <v-card-text class="pa-4 enr-course-description">
                      <v-expansion-panels v-model="clpsEnrDetailExpand" class="cstm-filter elevation-0" ref="attendees_expansion_panels">
                        <v-expansion-panel>
                          <v-expansion-panel-header hide-actions>
                            <span>
                              <v-icon dark>{{ clpsEnrDetailIcon }}</v-icon>
                              <span v-if="enrolment.vat">
                                {{ "(" + enrolment.vat + ") " + enrolment.name }}
                              </span>
                              <span v-else>{{ " " + $t("fe.enrolment.company_information") }}</span>
                            </span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="elevation-1">
                            <v-layout wrap>
                              <v-flex xs12>
                                <v-subheader class="pl-0">{{ $t("fe.enrolment.details") }}</v-subheader>

                                <v-layout wrap>
                                  <v-flex lg5 md6 sm9 xs12>
                                    <v-combobox
                                      name="o_name"
                                      v-model="enrolment.name"
                                      :items="organisations"
                                      item-text="text"
                                      item-value="vat"
                                      :label="$t('fe.enrolment.o_name')"
                                      autocomplete="new-password"
                                      :error-messages="errors.collect('o_name')"
                                      :disabled="fields_disabled"
                                      :search-input.sync="orgNameSearch"
                                      @change="updateOrgVat"
                                      clearable
                                    >
                                      <template v-slot:append>
                                        <span class="d-none">&nbsp;</span>
                                      </template>
                                      <template v-slot:append-item>
                                        <span class="d-none">&nbsp;</span>
                                      </template>
                                      <template v-slot:no-data>
                                        {{ $t("organisations.org_does_not_exist") }}
                                      </template>
                                      <template v-slot:item="{ index, item }"> {{ item.text }} ({{ item.vat }}) </template>
                                    </v-combobox>
                                  </v-flex>
                                  <v-flex lg3 md3 sm3 xs12>
                                    <v-text-field
                                      name="o_vat"
                                      v-model="enrolment.vat"
                                      class="required-field"
                                      v-validate="'required|max:9'"
                                      :label="$t('fe.enrolment.o_vat')"
                                      :error-messages="errors.collect('o_vat')"
                                      :disabled="fields_disabled"
                                      @keypress="$keyDown_IntOnly($event)"
                                      :hint="$t('global.helptext_vat')"
                                      persistent-hint
                                      :append-outer-icon="'sync'"
                                      @click:append-outer="searchOrgByVat(enrolment.vat)"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg4 md4 sm6 xs12>
                                    <v-text-field
                                      name="o_reference"
                                      v-model="enrolment.reference"
                                      v-validate="'max:50'"
                                      :label="$t('fe.enrolment.o_reference')"
                                      :error-messages="errors.collect('o_reference')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg3 md3 sm6 xs12>
                                    <v-text-field
                                      name="o_first_name"
                                      class="required-field"
                                      v-model="enrolment.first_name"
                                      v-validate="'max:50|required'"
                                      :label="$t('fe.enrolment.o_first_name')"
                                      :error-messages="errors.collect('o_first_name')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg3 md3 sm6 xs12>
                                    <v-text-field
                                      name="o_last_name"
                                      class="required-field"
                                      v-model="enrolment.last_name"
                                      v-validate="'max:50|required'"
                                      :label="$t('fe.enrolment.o_last_name')"
                                      :error-messages="errors.collect('o_last_name')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg3 md3 sm6 xs12>
                                    <v-text-field
                                      name="o_email"
                                      class="required-field"
                                      v-model="enrolment.email"
                                      v-validate="'email|max:255|required'"
                                      :label="$t('fe.enrolment.o_email')"
                                      :error-messages="errors.collect('o_email')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg3 md3 sm6 xs12>
                                    <vue-tel-input-vuetify
                                      :label="$t('fe.enrolment.p_mobile')"
                                      v-model="enrolment.mobile"
                                      @input="
                                        (formattedNumber, { number, valid, country }) => {
                                          enrolment.mobile = number.significant || formattedNumber
                                          enrolment.mobile_code = country.dialCode || null
                                        }
                                      "
                                      placeholder=""
                                      name="o_mobile"
                                      :error-messages="errors.collect('o_mobile')"
                                      defaultCountry="NO"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></vue-tel-input-vuetify>
                                    <!--<v-text-field
                                      name="o_mobile"
                                      v-model="enrolment.mobile"
                                      :label="$t('fe.enrolment.p_mobile')"
                                      :error-messages="errors.collect('o_mobile')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>-->
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-textarea
                                      name="p_comments"
                                      v-model="enrolment.comments"
                                      rows="2"
                                      auto-grow
                                      :label="$t('fe.enrolment.comment')"
                                      :error-messages="errors.collect('p_comments')"
                                      :v-validate="selectedCourseTypes.length > 0 ? '' : 'required'"
                                      :class="selectedCourseTypes.length > 0 ? '' : 'required-field'"
                                    ></v-textarea>
                                  </v-flex>
                                </v-layout>

                                <v-divider class="my-4"></v-divider>

                                <v-subheader class="pl-0">{{ $t("fe.enrolment.visiting_address") }}</v-subheader>

                                <v-layout wrap>
                                  <v-flex lg4 md4 sm6 xs12>
                                    <v-text-field
                                      name="o_v_address_street"
                                      v-model="enrolment.v_street"
                                      v-validate="'max:50'"
                                      :label="$t('fe.enrolment.o_address_street')"
                                      :error-messages="errors.collect('o_v_address_street')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg2 md2 sm4 xs12>
                                    <v-text-field
                                      name="o_v_address_zip"
                                      v-model="enrolment.v_zip"
                                      v-validate="'max:6'"
                                      :label="$t('fe.enrolment.o_address_zip')"
                                      :error-messages="errors.collect('o_v_address_zip')"
                                      :disabled="fields_disabled"
                                      @blur="visitingZipCodeChange"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg3 md2 sm6 xs12>
                                    <v-text-field
                                      name="o_v_address_city"
                                      v-model="enrolment.v_city"
                                      v-validate="'max:50'"
                                      :label="$t('fe.enrolment.o_address_city')"
                                      :error-messages="errors.collect('o_v_address_city')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg3 md2 sm6 xs12>
                                    <v-autocomplete
                                      name="o_v_address_country"
                                      v-model="enrolment.v_country"
                                      :items="this.$dd_countries()"
                                      item-text="text"
                                      item-value="key"
                                      :label="$t('fe.enrolment.o_address_country')"
                                      autocomplete="new-password"
                                      :error-messages="errors.collect('o_v_address_country')"
                                      :disabled="fields_disabled"
                                      clearable
                                    ></v-autocomplete>
                                  </v-flex>
                                </v-layout>

                                <v-divider class="my-4"></v-divider>

                                <v-subheader class="pl-0">{{ $t("fe.enrolment.invoice_address") }}</v-subheader>

                                <v-layout wrap>
                                  <v-flex lg4 md4 sm6 xs12>
                                    <v-text-field
                                      name="o_i_address_street"
                                      v-model="enrolment.i_street"
                                      v-validate="'max:50'"
                                      :label="$t('fe.enrolment.o_address_street')"
                                      :error-messages="errors.collect('o_i_address_street')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg2 md2 sm4 xs12>
                                    <v-text-field
                                      name="o_v_address_zip"
                                      v-model="enrolment.i_zip"
                                      v-validate="'max:6'"
                                      :label="$t('fe.enrolment.o_address_zip')"
                                      :error-messages="errors.collect('o_i_address_zip')"
                                      :disabled="fields_disabled"
                                      @blur="invoiceZipCodeChange"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg3 md2 sm6 xs12>
                                    <v-text-field
                                      name="o_i_address_city"
                                      v-model="enrolment.i_city"
                                      v-validate="'max:50'"
                                      :label="$t('fe.enrolment.o_address_city')"
                                      :error-messages="errors.collect('o_i_address_city')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex lg3 md2 sm6 xs12>
                                    <v-autocomplete
                                      name="o_v_address_country"
                                      v-model="enrolment.i_country"
                                      :items="this.$dd_countries()"
                                      item-text="text"
                                      item-value="key"
                                      :label="$t('fe.enrolment.o_address_country')"
                                      autocomplete="new-password"
                                      :error-messages="errors.collect('o_i_address_country')"
                                      :disabled="fields_disabled"
                                      clearable
                                    ></v-autocomplete>
                                  </v-flex>
                                  <v-flex lg3 md4 sm6 xs12>
                                    <v-text-field
                                      name="invoice_email"
                                      v-model="enrolment.invoice_email"
                                      v-validate="'email'"
                                      :label="$t('fe.enrolment.invoice_email')"
                                      :error-messages="errors.collect('invoice_email')"
                                      :disabled="fields_disabled"
                                      autocomplete="new-password"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>

                      <v-expansion-panels v-model="clpsEnrParExpand" class="cstm-filter mt-4 elevation-0" ref="attendees_expansion_panels">
                        <v-expansion-panel>
                          <v-expansion-panel-header hide-actions>
                            <span>
                              <v-icon dark>{{ clpsEnrParIcon }}</v-icon>
                              {{ $t("fe.enrolment.participants") }}
                            </span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="elevation-1">
                            <v-layout row wrap>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-text-field
                                  name="no_of_participants"
                                  type="number"
                                  v-model="no_of_participants"
                                  class="required-field"
                                  v-validate="'required'"
                                  :label="$t('fe.enrolment.no_of_participants')"
                                  :error-messages="errors.collect('no_of_participants')"
                                  :disabled="fields_disabled"
                                  autocomplete="new-password"
                                  min="1"
                                ></v-text-field>
                              </v-flex>
                              <v-flex lg8 md8 sm6 xs12></v-flex>

                              <v-flex xs12>
                                <div v-for="index in Number(no_of_participants)" :key="index">
                                  <v-layout row wrap>
                                    <v-flex lg3 md3 sm6 xs12>
                                      <v-text-field
                                        :name="$t('fe.enrolment.p_first_name') + ' [' + index - 1 + ']'"
                                        v-model="participants.first_name[index - 1]"
                                        class="required-field"
                                        v-validate="'required|max:50'"
                                        :label="$t('fe.enrolment.p_first_name')"
                                        :error-messages="
                                          $validator.errors.collect($t('fe.enrolment.p_first_name') + ' [' + (index - 1) + ']')
                                        "
                                        :disabled="fields_disabled"
                                        autocomplete="new-password"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6 xs12>
                                      <v-text-field
                                        :name="$t('fe.enrolment.p_last_name') + ' [' + (index - 1) + ']'"
                                        v-model="participants.last_name[index - 1]"
                                        class="required-field"
                                        v-validate="'required|max:50'"
                                        :label="$t('fe.enrolment.p_last_name')"
                                        :error-messages="
                                          $validator.errors.collect($t('fe.enrolment.p_last_name') + ' [' + (index - 1) + ']')
                                        "
                                        :disabled="fields_disabled"
                                        autocomplete="new-password"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6 xs12>
                                      <v-text-field
                                        :name="$t('fe.enrolment.p_email') + ' [' + (index - 1) + ']'"
                                        v-model="participants.email[index - 1]"
                                        class="required-field"
                                        v-validate="'required|email|max:255'"
                                        :label="$t('fe.enrolment.p_email')"
                                        :error-messages="$validator.errors.collect($t('fe.enrolment.p_email') + ' [' + (index - 1) + ']')"
                                        :disabled="fields_disabled"
                                        autocomplete="new-password"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex lg3 md3 sm6 xs12>
                                      <vue-tel-input-vuetify
                                        v-validate="'required|max:50'"
                                        :label="$t('fe.enrolment.p_mobile')"
                                        class="required-field"
                                        v-model="participants.mobile[index - 1]"
                                        @input="
                                          (formattedNumber, { number, valid, country }) => {
                                            participants.mobile[index - 1] = number.significant || formattedNumber
                                            participants.mobile_code[index - 1] = country.dialCode || null
                                          }
                                        "
                                        placeholder=""
                                        :name="$t('fe.enrolment.p_mobile') + ' [' + (index - 1) + ']'"
                                        :error-messages="$validator.errors.collect($t('fe.enrolment.p_mobile') + ' [' + (index - 1) + ']')"
                                        defaultCountry="NO"
                                        :disabled="fields_disabled"
                                      ></vue-tel-input-vuetify>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex lg4 md4 sm12 xs12 v-if="!enrolmentDone">
                  <v-card>
                    <v-card-text class="pa-4">
                      <p>{{ $t("fe.enrolment.interest_select_courstypes") }}</p>
                      <v-checkbox
                        v-for="coursetype in coursetypes"
                        :key="coursetype.id"
                        v-model="selectedCourseTypes"
                        :label="coursetype.name"
                        :value="coursetype.id"
                        hide-details
                      ></v-checkbox>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>

          <v-flex xs12 v-if="!enrolmentDone">
            <v-divider class="my-2"></v-divider>
            <v-card class="bottom-card">
              <v-card-text class="pa-1">
                <v-container grid-list-md class="pa-0">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-layout wrap>
                        <vue-recaptcha ref="recaptcha" class="captcha d-none" mx-auto :sitekey="RECAPTCHA_KEY"> </vue-recaptcha>

                        <v-flex xs12 class="text-center">
                          <v-checkbox name="coursetype" dense v-model="accept_privacy" v-validate="'required'" class="d-inline-flex">
                          </v-checkbox>
                          <p class="d-inline-flex va-top privacy-line">
                            {{ $t("fe.enrolment.privacy_consent_to") }}
                            <a @click="show_policy = !show_policy" class="pl-1 privacy-link">{{ $t("fe.enrolment.privacy_notice") }}</a>
                          </p>

                          <br />

                          <v-btn class="mb-3" color="primary" large @click="validateEnrol" :disabled="fields_disabled || !accept_privacy">{{
                            $t("fe.enrolment.submit_interest")
                          }}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 v-if="enrolmentDone">
            <v-card class="mx-auto mt-10" max-width="50%" color="success" dark>
              <v-card-title class="headline">{{ $t("fe.enrolment.enrolment_success_noemailsms") }}</v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <privacyPolicy :show="show_policy" :locale="locale" @callback_privacy_cancel="show_policy = false" />
  </v-container>
</template>

<script>
import _ from "lodash"
import { VueRecaptcha } from "@/mixins/vue-recaptcha"
import privacyPolicy from "../partials/Privacy"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "EnrolmentOrganisationInterest",

  props: ["locale"],

  components: {
    VueRecaptcha,
    privacyPolicy,
    VueTelInputVuetify
  },

  data() {
    return {
      page_title: "",

      enrolment: {
        name: ""
      },
      enrolmentDone: false,

      coursetypes: [],
      selectedCourseTypes: [],

      available_enrolment: 0,
      fields_disabled: false,
      accept_privacy: false,
      show_policy: false,

      organisations: [],
      orgNameSearch: null,

      recaptchaData: null,

      clpsEnrDetailExpand: 0,
      clpsEnrDetailIcon: "mdi-collapse-all-outline",
      clpsEnrParExpand: 0,
      clpsEnrParIcon: "mdi-collapse-all-outline",

      participants: {
        first_name: [],
        last_name: [],
        email: [],
        mobile: [],
        mobile_code: []
      },
      active_tab: 0, // personal
      dob_date_menu: false,
      no_of_participants: 1,

      dictionary: {
        attributes: {
          o_course_id: this.$t("fe.enrolment.o_course_id"),
          o_vat: this.$t("fe.enrolment.o_vat"),
          o_reference: this.$t("fe.enrolment.o_reference"),
          o_name: this.$t("fe.enrolment.o_name"),
          o_first_name: this.$t("fe.enrolment.o_first_name"),
          o_last_name: this.$t("fe.enrolment.o_last_name"),
          o_email: this.$t("fe.enrolment.o_email"),
          o_custom_number: this.$t("fe.enrolment.o_customer_number"),
          o_v_address_street: this.$t("fe.enrolment.o_address_street"),
          o_v_address_city: this.$t("fe.enrolment.o_address_city"),
          o_v_address_state: this.$t("fe.enrolment.o_address_state"),
          o_v_address_zip: this.$t("fe.enrolment.o_address_zip"),
          o_v_address_country: this.$t("fe.enrolment.o_address_country"),
          o_i_address_street: this.$t("fe.enrolment.o_address_street"),
          o_i_address_city: this.$t("fe.enrolment.o_address_city"),
          o_i_address_state: this.$t("fe.enrolment.o_address_state"),
          o_i_address_zip: this.$t("fe.enrolment.o_address_zip"),
          o_i_address_country: this.$t("fe.enrolment.o_address_country"),
          invoice_email: this.$t("fe.enrolment.invoice_email"),
          no_of_participants: this.$t("fe.enrolment.no_of_participants"),

          p_first_name: this.$t("fe.enrolment.p_first_name"),
          p_last_name: this.$t("fe.enrolment.p_last_name"),
          p_email: this.$t("fe.enrolment.p_email"),
          p_mobile: this.$t("fe.enrolment.p_mobile"),
          p_comments: this.$t("fe.enrolment.comment"),

          coursetype: this.$t("moduleoptioncoursetypes.coursetype_id")
        }
      }
    }
  },

  computed: {
    computedCourseStartDate() {
      return this.course.start_date ? this.moment.utc(this.course.start_date).format(this.DATE_FORMAT) : ""
    },
    computedCourseStartTime() {
      return this.course.start_time ? this.moment.utc(this.course.start_time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    },
    computedCourseEndDate() {
      return this.course.end_date ? this.moment.utc(this.course.end_date).format(this.DATE_FORMAT) : ""
    },
    computedCourseEndTime() {
      return this.course.end_time ? this.moment.utc(this.course.end_time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    }
  },

  watch: {
    orgNameSearch: {
      handler: _.debounce(function (search) {
        this.searchOrgVatByName(search)
      }, 300)
    },
    clpsEnrDetailExpand: {
      handler(newVal, oldVal) {
        this.clpsEnrDetailIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsEnrParExpand: {
      handler(newVal, oldVal) {
        this.clpsEnrParIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    }
  },

  created() {
    let vm = this

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    axios
      .get(this.API_URL + "open/organisation/my")
      .then((res) => {
        let data = res.data.data
        this.$store.dispatch("frontend/setOrganisation", data)

        this.$setTenantInAxiosHeader(data.tenant_id)

        this.enrolment.country = this.$getDefaultDropdown(this.$dd_countries())
        this.enrolment.mobile_code = "47"

        axios.get(this.API_URL + "open/coursetypes?show_all=true&query_register_interest=1").then((res) => {
          this.coursetypes = res.data.data
        })
      })
      .catch((err) => console.log(err))
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  methods: {
    validateEnrol() {
      this.$validator.validate()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.enrol()
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },

    enrol() {
      let vm = this

      let vdata = []
      let participants = []

      for (let i = 0; i <= this.no_of_participants - 1; i++) {
        if (this.participants.first_name[i] && this.participants.last_name[i] && this.participants.email[i]) {
          vdata[i] = {
            course_id: null,
            first_name: this.participants.first_name[i],
            last_name: this.participants.last_name[i],
            email: this.participants.email[i]
          }
        }

        this.participants.mobile[i] = this.$formatPhoneNumber(this.participants.mobile[i], this.participants.mobile_code[i])
      }

      // remove excess participants
      this.participants.first_name.length = this.no_of_participants
      this.participants.last_name.length = this.no_of_participants
      this.participants.email.length = this.no_of_participants
      this.participants.mobile.length = this.no_of_participants
      this.participants.mobile_code.length = this.no_of_participants

      console.log(vdata)
      console.log(this.participants)

      axios
        .post(this.API_URL + "open/enrolment/validate", {
          data: JSON.stringify(vdata)
        })
        .then((res) => {
          let status = res.data.status
          let duplicates = res.data.duplicates

          if (res.data.status == "not-valid") {
            if (duplicates.length > 0) {
              let names = []

              duplicates.forEach((item, index) => {
                names[index] = item.first_name + " " + item.last_name
              })

              vm.$awn.alert(
                vm.$t("fe.enrolment.enrolment_duplicate", {
                  names: names.join(", ")
                })
              )
            }
          } else {
            axios
              .post(this.API_URL + "open/enrolment", {
                site: process.env.VUE_APP_DOMAIN,
                subdomain: vm.SUBDOMAIN,
                course_id: null,
                reference: this.enrolment.reference,
                vat: this.enrolment.vat,
                name: this.enrolment.name,
                first_name: this.enrolment.first_name,
                last_name: this.enrolment.last_name,
                email: this.enrolment.email,
                mobile: this.$formatPhoneNumber(this.enrolment.mobile, this.enrolment.mobile_code),
                v_street: this.enrolment.v_street,
                v_city: this.enrolment.v_city,
                v_state: "",
                v_zip: this.enrolment.v_zip,
                v_country: this.enrolment.v_country,
                i_street: this.enrolment.i_street,
                i_city: this.enrolment.i_city,
                i_state: "",
                i_zip: this.enrolment.i_zip,
                i_country: this.enrolment.i_country,
                invoice_email: this.enrolment.invoice_email,
                comments: this.enrolment.comments,
                created_by: null,
                participants: this.participants,
                type: "organisation",
                mode: "interest",
                coursetypes: this.selectedCourseTypes.join(","),
                course_full: Boolean(this.available_enrolment <= 0)
              })
              .then((res) => {
                if (typeof res.data.errors !== "undefined") {
                } else {
                  let ids = res.data.ids || null

                  if (ids) {
                    vm.participants = {
                      first_name: [],
                      last_name: [],
                      email: [],
                      mobile: []
                    }
                    vm.$refs.form.reset()
                    vm.no_of_participants = 1
                    vm.accept_privacy = false
                    vm.errors.items = []

                    vm.enrolmentDone = true
                    window.scrollTo(0, 0)
                  } else {
                    vm.$swal({
                      text: vm.$t("fe.enrolment.enrolment_error"),
                      icon: "error",
                      closeOnClickOutside: false,
                      closeOnEsc: false
                    })
                  }
                }
              })
              .catch((err) => console.log(err))
          }
        })
        .catch((err) => console.log(err))
    },

    searchOrgByVat(search) {
      let vm = this

      if (search) {
        this.organisations = []

        axios
          .get(this.BRREG_API_URL + search)
          .then((res) => {
            let data = res.data
            let companyname = this.$formatAPICompanyName(data.navn)
            this.organisations.push({
              key: companyname,
              text: companyname,
              vat: data.organisasjonsnummer
            })
            // Automaticlly set the organisation name
            this.$set(this.enrolment, "name", companyname || null)
            this.$set(this.enrolment, "vat", data.organisasjonsnummer || null)
          })
          .catch(function(error) {
            vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
            vm.$set(vm.enrolment, "name", null)
            vm.$set(vm.enrolment, "vat", null)
          })

        // let promise = this.$api1881SearchVAT(search)
        // promise
        //   .then((res) => {
        //     let data = res.data
        //     if (data && data.contacts) {
        //       this.organisations = data.contacts.map((item) => {
        //         return {
        //           id: item.id,
        //           key: item.name,
        //           text: item.name,
        //           vat: item.organizationNumber
        //         }
        //       })

        //       this.$set(this.enrolment, "name", this.organisations.length ? this.organisations[0].text : null)
        //       this.$set(this.enrolment, "vat", this.organisations.length ? this.organisations[0].vat : null)
        //     } else {
        //       vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //     }
        //   })
        //   .catch(function (error) {
        //     vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //   })
      }
    },
    searchOrgVatByName(search) {
      if (search) {
        this.organisations = []

        let org = this.organisations.find((i) => i.key == search)
        if (org && org.vat) {
        } else {
          axios
            .get(this.BRREG_API_URL + "?navn=" + search)
            .then((res) => {
              let data = res.data
              if (data.page.totalElements > 0) {
                this.organisations = data._embedded.enheter.slice(0, 3).map((item) => {
                  let companyname = this.$formatAPICompanyName(item.navn)
                  return {
                    key: companyname,
                    text: companyname,
                    vat: item.organisasjonsnummer,
                  }
                })
              }
            })
            .catch(function(error) {})
        }

        // let promise = this.$api1881SearchName(search)
        // promise.then((res) => {
        //   let data = res.data
        //   if (data && data.contacts) {
        //     this.organisations = data.contacts.map((item) => {
        //       return {
        //         id: item.id,
        //         key: item.name,
        //         text: item.name,
        //         vat: item.organizationNumber
        //       }
        //     })
        //   }
        // })
      }
    },
    updateOrgVat() {
      if (this.enrolment.name && typeof this.enrolment.name === "object") {
        let org = this.organisations.find((i) => i.key == this.enrolment.name.key)
        if (org) {
          this.$set(this.enrolment, "name", org.text || null)
          this.$set(this.enrolment, "vat", org.vat || null)
          return
        }

        // let org = this.organisations.find((i) => i.vat == this.enrolment.name.vat)
        // if (org) {
        //   let promise = this.$api1881SearchID(org.id)
        //   promise
        //     .then((res) => {
        //       let data = res.data
        //       if (data && data.contacts) {
        //         data = data.contacts[0]

        //         this.$set(this.enrolment, "v_street", data.geography.address.street + " " + data.geography.address.houseNumber)
        //         this.$set(this.enrolment, "v_zip", data.geography.address.postCode)
        //         this.$set(this.enrolment, "v_city", data.geography.address.postArea)
        //         this.$set(this.enrolment, "v_state", data.geography.county)
        //       }
        //     })
        //     .catch(function (error) {
        //       console.log(error)
        //     })

        //   this.$set(this.enrolment, "name", org.text)
        //   this.$set(this.enrolment, "vat", org.vat)
        //   return
        // }
      }

      this.$set(this.enrolment, "name", this.enrolment.name || null)
      this.$set(this.enrolment, "vat", null)

      this.$set(this.enrolment, "v_street", null)
      this.$set(this.enrolment, "v_zip", null)
      this.$set(this.enrolment, "v_city", null)
      this.$set(this.enrolment, "v_state", null)
    },

    visitingZipCodeChange() {
      this.$getCity(this.enrolment.v_zip, this.enrolment.v_country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.enrolment, "v_city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.enrolment, "v_city", null)
        })
    },
    invoiceZipCodeChange() {
      this.$getCity(this.enrolment.i_zip, this.enrolment.i_country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.enrolment, "i_city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.enrolment, "i_city", null)
        })
    }
  }
}
</script>

<style scoped>
.privacy-line {
  margin-top: 22px;
}
.privacy-link {
  font-size: 14px;
}
.chk-moduleoption {
  height: 30px;
  padding-top: 3px;
  margin-top: 0;
}
.bottom-card {
  box-shadow: none !important;
}
</style>
